(function () {
  function createTextLayer(text, className) {
    const layer = document.createElement('span');
    layer.className = className;
    if (className.includes('ghost')) {
      layer.setAttribute('aria-hidden', 'true');
    }

    const word = document.createElement('span');
    word.className = 'laau-nav-word';

    let index = 0;
    for (const char of text) {
      if (char === ' ') {
        word.appendChild(document.createTextNode('\u00a0'));
        continue;
      }

      const charSpan = document.createElement('span');
      charSpan.className = 'laau-nav-char';
      charSpan.textContent = char;
      charSpan.dataset.laauDir = index % 2 === 0 ? 'down' : 'up';
      word.appendChild(charSpan);
      index += 1;
    }

    layer.appendChild(word);
    return layer;
  }

  function wrapNavLetters(titleEl) {
    if (!titleEl) return false;
    if (titleEl.querySelector('.laau-nav-animation-wrapper')) return true;

    const text = titleEl.textContent.trim();
    if (!text) return false;

    titleEl.textContent = '';
    titleEl.classList.add('laau-nav-title');

    const wrapper = document.createElement('span');
    wrapper.className = 'laau-nav-animation-wrapper';
    wrapper.appendChild(createTextLayer(text, 'laau-nav-animation'));
    wrapper.appendChild(createTextLayer(text, 'laau-nav-animation laau-nav-animation--ghost'));
    titleEl.appendChild(wrapper);
    return true;
  }

  function getPrimaryNavLinks(list) {
    return [...list.querySelectorAll('.menu-list__link')].filter(
      (link) => link.getAttribute('slot') !== 'overflow' && !link.closest('[slot="overflow"]'),
    );
  }

  function initLaauNavList(list) {
    if (!list || list.dataset.laauNavListReady === 'true') return;
    list.dataset.laauNavListReady = 'true';
    list.classList.add('laau-nav-list');

    let indicator = list.querySelector(':scope > .laau-nav-indicator');
    if (!indicator) {
      indicator = document.createElement('span');
      indicator.className = 'laau-nav-indicator';
      indicator.setAttribute('aria-hidden', 'true');
      list.appendChild(indicator);
    }

    let activeLink = null;

    const setActiveLink = (link) => {
      if (activeLink === link) return;
      activeLink = link || null;

      getPrimaryNavLinks(list).forEach((item) => {
        item.classList.toggle('is-laau-nav-hover', item === activeLink);
      });
    };

    const moveIndicator = (link) => {
      if (!link) {
        indicator.style.opacity = '0';
        return;
      }

      const title = link.querySelector('.menu-list__link-title') || link;
      const listRect = list.getBoundingClientRect();
      const rect = title.getBoundingClientRect();
      indicator.style.width = rect.width + 'px';
      indicator.style.transform = 'translate3d(' + (rect.left - listRect.left) + 'px, 0, 0)';
      indicator.style.opacity = '1';
    };

    const resolveLink = (target) => {
      const link = target?.closest?.('.menu-list__link');
      if (!link || !list.contains(link)) return null;
      if (link.getAttribute('slot') === 'overflow' || link.closest('[slot="overflow"]')) return null;
      return link;
    };

    list.addEventListener('mouseover', (event) => {
      const link = resolveLink(event.target);
      if (!link) return;
      wrapNavLetters(link.querySelector('.menu-list__link-title'));
      setActiveLink(link);
      moveIndicator(link);
    });

    list.addEventListener('mouseleave', (event) => {
      if (event.relatedTarget && list.contains(event.relatedTarget)) return;
      setActiveLink(null);
      moveIndicator(null);
    });

    list.addEventListener('focusin', (event) => {
      const link = resolveLink(event.target);
      if (!link) return;
      wrapNavLetters(link.querySelector('.menu-list__link-title'));
      setActiveLink(link);
      moveIndicator(link);
    });

    list.addEventListener('focusout', () => {
      window.requestAnimationFrame(() => {
        if (list.contains(document.activeElement)) return;
        if (list.matches(':hover')) return;
        setActiveLink(null);
        moveIndicator(null);
      });
    });

    getPrimaryNavLinks(list).forEach((link) => {
      wrapNavLetters(link.querySelector('.menu-list__link-title'));
    });

    const current = list.querySelector('.menu-list__link--active, .menu-list__link[aria-current="page"]');
    if (current) moveIndicator(current);
  }

  function initLaauLogo3d() {
    document.querySelectorAll('.header-logo__image-container').forEach((container) => {
      if (container.dataset.laauLogo3dInit === 'true') return;

      const source = container.querySelector('picture, img');
      if (!source) return;

      container.dataset.laauLogo3dInit = 'true';
      container.classList.add('laau-logo-3d');

      const imgEl = source.tagName === 'IMG' ? source : source.querySelector('img');
      const measuredW = Math.round(imgEl?.getBoundingClientRect().width || imgEl?.clientWidth || 36);
      const measuredH = Math.round(imgEl?.getBoundingClientRect().height || imgEl?.clientHeight || 36);
      container.style.setProperty('--laau-logo-w', `${Math.max(measuredW, 28)}px`);
      container.style.setProperty('--laau-logo-h', `${Math.max(measuredH, 28)}px`);

      const stage = document.createElement('span');
      stage.className = 'laau-logo-3d__stage';

      const spinner = document.createElement('span');
      spinner.className = 'laau-logo-3d__spinner';

      const faceFront = document.createElement('span');
      faceFront.className = 'laau-logo-3d__face laau-logo-3d__face--front';
      faceFront.appendChild(source);

      const faceBack = document.createElement('span');
      faceBack.className = 'laau-logo-3d__face laau-logo-3d__face--back';
      faceBack.appendChild(source.cloneNode(true));

      spinner.appendChild(faceFront);
      spinner.appendChild(faceBack);
      stage.appendChild(spinner);
      container.appendChild(stage);

      spinner.style.transform = 'rotateX(12deg) rotateY(0deg)';
    });
  }



  function initLaauProductCardPreview() {
    document.querySelectorAll('.product-card .card-gallery').forEach((gallery) => {
      if (gallery.dataset.laauPreviewBound === 'true') return;
      gallery.dataset.laauPreviewBound = 'true';

      gallery.addEventListener('pointerenter', () => {
        gallery.classList.add('is-laau-previewing');
      });

      gallery.addEventListener('pointerleave', () => {
        gallery.classList.remove('is-laau-previewing');
      });

      gallery.addEventListener('animationend', (event) => {
        if (event.animationName === 'laau-card-shimmer') {
          gallery.classList.remove('is-laau-previewing');
        }
      });
    });
  }


  function initLaauHeaderScroll() {
    if (document.documentElement.dataset.laauHeaderScrollBound === 'true') return;
    document.documentElement.dataset.laauHeaderScrollBound = 'true';

    const threshold = 16;
    let ticking = false;

    function update() {
      document.documentElement.classList.toggle('is-laau-header-scrolled', window.scrollY > threshold);
      ticking = false;
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }

    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('pagereveal', update);
  }

  function initLaauNav() {
    initLaauHeaderScroll();
    initLaauLogo3d();
    document.querySelectorAll('.menu-list__link .menu-list__link-title').forEach((titleEl) => {
      wrapNavLetters(titleEl);
    });
    document.querySelectorAll('.menu-list__list').forEach(initLaauNavList);
  }

  function scheduleInit() {
    initLaauNav();
    initLaauProductCardPreview();
    initLaauHero();
    requestAnimationFrame(initLaauNav);
    window.setTimeout(initLaauNav, 120);
    window.setTimeout(initLaauNav, 450);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleInit);
    document.addEventListener('DOMContentLoaded', scheduleHeroInit);
  } else {
    scheduleInit();
    scheduleHeroInit();
  }

  document.addEventListener('shopify:section:load', scheduleInit);
  document.addEventListener('shopify:section:load', initLaauProductCardPreview);
  document.addEventListener('shopify:section:load', scheduleHeroInit);

  const headerRoot = document.querySelector('#header-group');
  if (headerRoot && typeof MutationObserver !== 'undefined') {
    let debounceTimer;
    const observer = new MutationObserver(() => {
      window.clearTimeout(debounceTimer);
      debounceTimer = window.setTimeout(initLaauNav, 60);
    });
    observer.observe(headerRoot, { childList: true, subtree: true });
  }


  function initLaauHero() {
    const section = document.querySelector(
      '#MainContent[data-template="index"] .shopify-section:first-of-type',
    );
    if (!section) return;

    const wrapper = section.querySelector('.hero__content-wrapper');
    if (wrapper && !wrapper.classList.contains('laau-hero-stage')) {
      wrapper.classList.add('laau-hero-stage');
    }

    const cta = section.querySelector('.hero__content a.button, .hero__content .button');
    if (cta && cta.dataset.laauHeroCta !== 'true') {
      cta.dataset.laauHeroCta = 'true';
      cta.classList.add('laau-hero-cta');
      const label = cta.textContent.trim();
      cta.textContent = '';

      const labelSpan = document.createElement('span');
      labelSpan.className = 'laau-hero-cta__label';
      labelSpan.textContent = label;

      const arrowSpan = document.createElement('span');
      arrowSpan.className = 'laau-hero-cta__arrow';
      arrowSpan.setAttribute('aria-hidden', 'true');
      arrowSpan.textContent = '→';

      cta.appendChild(labelSpan);
      cta.appendChild(arrowSpan);
    }
  }


  function scheduleHeroInit() {
    initLaauHero();
    requestAnimationFrame(initLaauHero);
  }

  function resetNavHover() {
    document.querySelectorAll('.menu-list__link.is-laau-nav-hover').forEach((link) => {
      link.classList.remove('is-laau-nav-hover');
    });
    document.querySelectorAll('.laau-nav-list .laau-nav-indicator').forEach((indicator) => {
      indicator.style.opacity = '0';
    });
  }

  let pageEntered = false;

  function markPageEntered() {
    if (pageEntered) return;
    pageEntered = true;
    document.documentElement.classList.add('laau-page-entered');
    resetNavHover();
    initLaauHero();
  }

  document.addEventListener(
    'click',
    (event) => {
      const link = event.target.closest('a[href]');
      if (!link || link.target === '_blank') return;

      let url;
      try {
        url = new URL(link.href, window.location.href);
      } catch {
        return;
      }

      if (url.origin !== window.location.origin) return;
      if (url.pathname === window.location.pathname && url.search === window.location.search) return;
      resetNavHover();
    },
    true,
  );

  window.addEventListener('pageswap', resetNavHover);

  window.addEventListener('pagereveal', (event) => {
    const viewTransition = event.viewTransition;
    if (viewTransition && typeof viewTransition.finished?.then === 'function') {
      viewTransition.finished.then(markPageEntered).catch(markPageEntered);
      return;
    }
    markPageEntered();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', markPageEntered, { once: true });
  } else {
    markPageEntered();
  }
  window.setTimeout(markPageEntered, 1500);
})();
